// src/components/Pengaturan.jsx
import React, { useEffect, useState } from "react";

// ─── Icon Mata 
const EyeIcon = ({ open }) =>
  open ? (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  );

// ─── Password Input dengan toggle show/hide 
const PasswordInput = ({ placeholder, value, onChange, required, className }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        className={`w-full rounded-xl border px-3 py-2 pr-10 ${className || ""}`}
        type={show ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600"
        tabIndex={-1}
      >
        <EyeIcon open={show} />
      </button>
    </div>
  );
};

export default function PengaturanPage({ api, auth }) {
  const userRole = auth?.user?.role || "anggota";
  const isAdmin = userRole === "administrator";

  // --- State Ubah Password ---
  const [passForm, setPassForm] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [passLoading, setPassLoading] = useState(false);

  // --- State Reset Password (Admin) ---
  const [resetForm, setResetForm] = useState({
    user_id: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [resetLoading, setResetLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  // --- State Setting Bunga ---
  const [bunga, setBunga] = useState("");
  const [bungaLoading, setBungaLoading] = useState(false);

  // --- State Setting Simpanan Wajib ---
  const [simpananWajib, setSimpananWajib] = useState({
    nominal: "",
    kenaikan_tahun: "1",
  });
  const [simpananWajibLoading, setSimpananWajibLoading] = useState(false);

  useEffect(() => {
    if (isAdmin) fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSettings = async () => {
    try {
      const { data } = await api.get("/settings");
      setBunga(data?.bunga_pinjaman?.value || "");
      setSimpananWajib({
        nominal: data?.simpanan_wajib_nominal?.value || "150000",
        kenaikan_tahun: data?.simpanan_wajib_kenaikan_tahun?.value || "1",
      });
    } catch (e) {
      console.error(e);
    }
  };

  const searchMembers = async (query) => {
    if (query.length < 2) {
      setSearchResults([]);
      return;
    }
    try {
      setSearchLoading(true);
      const { data } = await api.get(`/members?search=${query}&per_page=8`);
      setSearchResults(data.data || data);
    } catch (e) {
      console.error(e);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passForm.new_password !== passForm.new_password_confirmation) {
      alert("Konfirmasi password baru tidak cocok.");
      return;
    }
    try {
      setPassLoading(true);
      await api.put("/user/change-password", passForm);
      alert("Password berhasil diubah.");
      setPassForm({ current_password: "", new_password: "", new_password_confirmation: "" });
    } catch (e) {
      alert("Gagal: " + (e.response?.data?.message || e.message));
    } finally {
      setPassLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (resetForm.new_password !== resetForm.new_password_confirmation) {
      alert("Konfirmasi password baru tidak cocok.");
      return;
    }
    try {
      setResetLoading(true);
      await api.put("/user/reset-password", {
        user_id: resetForm.user_id,
        new_password: resetForm.new_password,
        new_password_confirmation: resetForm.new_password_confirmation,
      });
      alert("Password anggota berhasil direset.");
      setResetForm({ user_id: "", new_password: "", new_password_confirmation: "" });
      setSelectedMember(null);
      setSearchQuery("");
    } catch (e) {
      alert("Gagal: " + (e.response?.data?.message || e.message));
    } finally {
      setResetLoading(false);
    }
  };

  const handleSaveBunga = async (e) => {
    e.preventDefault();
    try {
      setBungaLoading(true);
      await api.put("/settings", { bunga_pinjaman: bunga });
      alert("Pengaturan bunga berhasil disimpan.");
    } catch (e) {
      alert("Gagal: " + (e.response?.data?.message || e.message));
    } finally {
      setBungaLoading(false);
    }
  };

  const handleSaveSimpananWajib = async (e) => {
    e.preventDefault();
    try {
      setSimpananWajibLoading(true);
      await api.put("/settings", {
        simpanan_wajib_nominal: simpananWajib.nominal,
        simpanan_wajib_kenaikan_tahun: simpananWajib.kenaikan_tahun,
      });
      alert("Pengaturan simpanan wajib berhasil disimpan.");
    } catch (e) {
      alert("Gagal: " + (e.response?.data?.message || e.message));
    } finally {
      setSimpananWajibLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">Pengaturan Sistem</h2>
      </div>

      {/* ── Section Ubah Password ── */}
      <div className="rounded-2xl bg-white border p-5 space-y-3">
        <h3 className="font-semibold text-slate-700 mb-1">Ubah Password</h3>
        <p className="text-xs text-slate-400 mb-2">
          Masukkan password lama dan password baru. Minimal 8 karakter.
        </p>
        <form onSubmit={handleChangePassword} className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <PasswordInput
            placeholder="Password Lama"
            value={passForm.current_password}
            onChange={(e) => setPassForm((f) => ({ ...f, current_password: e.target.value }))}
            required
          />
          <PasswordInput
            placeholder="Password Baru"
            value={passForm.new_password}
            onChange={(e) => setPassForm((f) => ({ ...f, new_password: e.target.value }))}
            required
          />
          <PasswordInput
            placeholder="Konfirmasi Password Baru"
            value={passForm.new_password_confirmation}
            onChange={(e) => setPassForm((f) => ({ ...f, new_password_confirmation: e.target.value }))}
            required
          />
          <button
            type="submit"
            disabled={passLoading}
            className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-xl py-2 text-sm font-medium transition-colors md:col-span-3"
          >
            {passLoading ? "Menyimpan..." : "Ubah Password"}
          </button>
        </form>
      </div>

      {/* ── Section Reset Password Anggota - Hanya Admin ── */}
      {isAdmin && (
        <div className="rounded-2xl bg-white border p-5 space-y-3">
          <h3 className="font-semibold text-slate-700 mb-1">Reset Password Anggota</h3>
          <p className="text-xs text-slate-400 mb-2">
            Reset password anggota yang lupa passwordnya tanpa perlu password lama.
          </p>
          <form onSubmit={handleResetPassword} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="relative md:col-span-3">
              {selectedMember ? (
                <div className="flex items-center justify-between rounded-xl border px-3 py-2 bg-slate-50">
                  <span className="text-sm text-slate-700">
                    {selectedMember.name}
                    {selectedMember.member_no && (
                      <span className="ml-2 text-xs text-slate-400">({selectedMember.member_no})</span>
                    )}
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedMember(null);
                      setResetForm((f) => ({ ...f, user_id: "" }));
                      setSearchQuery("");
                      setSearchResults([]);
                    }}
                    className="text-slate-400 hover:text-red-500 text-xs ml-2"
                  >
                    ✕ Ganti
                  </button>
                </div>
              ) : (
                <>
                  <input
                    className="w-full rounded-xl border px-3 py-2"
                    type="text"
                    placeholder="Cari nama anggota..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      searchMembers(e.target.value);
                    }}
                  />
                  {(searchResults.length > 0 || searchLoading) && (
                    <div className="absolute z-10 w-full mt-1 bg-white border rounded-xl shadow-lg overflow-hidden">
                      {searchLoading ? (
                        <div className="px-4 py-3 text-sm text-slate-400">Mencari...</div>
                      ) : (
                        searchResults.map((m) => (
                          <button
                            key={m.id}
                            type="button"
                            onClick={() => {
                              setSelectedMember(m);
                              setResetForm((f) => ({ ...f, user_id: m.user_id || m.id }));
                              setSearchQuery("");
                              setSearchResults([]);
                            }}
                            className="w-full text-left px-4 py-2 text-sm hover:bg-slate-50 border-b last:border-b-0"
                          >
                            <span className="font-medium text-slate-700">{m.name}</span>
                            {m.member_no && (
                              <span className="ml-2 text-xs text-slate-400">{m.member_no}</span>
                            )}
                          </button>
                        ))
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
            <PasswordInput
              placeholder="Password Baru"
              value={resetForm.new_password}
              onChange={(e) => setResetForm((f) => ({ ...f, new_password: e.target.value }))}
              required
            />
            <PasswordInput
              placeholder="Konfirmasi Password Baru"
              value={resetForm.new_password_confirmation}
              onChange={(e) => setResetForm((f) => ({ ...f, new_password_confirmation: e.target.value }))}
              required
            />
            <button
              type="submit"
              disabled={resetLoading || !selectedMember}
              className="bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white rounded-xl py-2 text-sm font-medium transition-colors"
            >
              {resetLoading ? "Mereset..." : "Reset Password"}
            </button>
          </form>
        </div>
      )}

      {/* ── Section Setting Bunga - Hanya Admin ── */}
      {isAdmin && (
        <div className="rounded-2xl bg-white border p-5 space-y-3">
          <h3 className="font-semibold text-slate-700 mb-1">Setting Bunga Pinjaman</h3>
          <p className="text-xs text-slate-400 mb-2">
            Bunga ini akan digunakan sebagai default saat pengajuan pinjaman baru.
          </p>
          <form onSubmit={handleSaveBunga} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="relative">
              <input
                className="w-full rounded-xl border px-3 py-2 pr-8"
                type="number"
                step="0.01"
                min="0"
                max="100"
                placeholder="Persentase bunga"
                value={bunga}
                onChange={(e) => setBunga(e.target.value)}
                required
              />
              <span className="absolute right-3 top-2.5 text-slate-400 text-sm">%</span>
            </div>
            <button
              type="submit"
              disabled={bungaLoading}
              className="bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white rounded-xl py-2 text-sm font-medium transition-colors"
            >
              {bungaLoading ? "Menyimpan..." : "Simpan Pengaturan"}
            </button>
          </form>
        </div>
      )}

      {/* ── Section Setting Simpanan Wajib - Hanya Admin ── */}
      {isAdmin && (
        <div className="rounded-2xl bg-white border p-5 space-y-3">
          <h3 className="font-semibold text-slate-700 mb-1">Setting Simpanan Wajib</h3>
          <p className="text-xs text-slate-400 mb-2">
            Nominal simpanan wajib per bulan dan periode kenaikannya.
          </p>
          <form onSubmit={handleSaveSimpananWajib} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="relative">
              <span className="absolute left-3 top-2.5 text-slate-400 text-sm">Rp</span>
              <input
                className="w-full rounded-xl border px-3 py-2 pl-9"
                type="number"
                min="0"
                step="1000"
                placeholder="Nominal simpanan wajib"
                value={simpananWajib.nominal}
                onChange={(e) => setSimpananWajib((s) => ({ ...s, nominal: e.target.value }))}
                required
              />
            </div>
            <select
              className="rounded-xl border px-3 py-2"
              value={simpananWajib.kenaikan_tahun}
              onChange={(e) => setSimpananWajib((s) => ({ ...s, kenaikan_tahun: e.target.value }))}
            >
              <option value="1">Naik setiap 1 tahun</option>
              <option value="2">Naik setiap 2 tahun</option>
            </select>
            <button
              type="submit"
              disabled={simpananWajibLoading}
              className="bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white rounded-xl py-2 text-sm font-medium transition-colors"
            >
              {simpananWajibLoading ? "Menyimpan..." : "Simpan Pengaturan"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}